<template>
  <div class="editorPageContact">
    <div class="editorPageContact__top">
      <div class="editorPageContact__topInner container">
        <div v-if="data.top.length" class="editorPageContact__tiles">
          <div class="editorPageContact__tile" v-for="(tile, index) in data.top" :key="index">
            <img :src="JSON.parse(tile.Icon).url" alt="" class="editorPageContact__tileIcon" />
            <div class="editorPageContact__tileContent">
              <h2 class="editorPageContact__tileContentTitle">{{ tile.Title }}</h2>
              <div class="editorPageContact__tileContentText" v-html="tile.Details" />
            </div>
          </div>
        </div>
      </div>
      <img src="/images/contact-shape.svg" alt="" class="editorPageContact__topBg" />
    </div>
    <div class="editorPageContact__bottom">
      <div class="editorPageContact__bottomInner container">
        <div class="editorPageContact__formWrapper">
          <h2 class="editorPageContact__formTitle">Formularz kontaktowy</h2>
          <VForm>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form
                class="editorPageContact__form"
                autocomplete="off"
                @submit.prevent="handleSubmit(onSubmit)"
              >
                <div class="editorPageContact__fields">
                  <ValidationProvider v-slot="{ classes, errors }" rules="required">
                    <FormField
                      v-model="name"
                      name="name"
                      type="text"
                      label="Imię i nazwisko"
                      :class="[classes, 'editorPageContact__formField']"
                    >
                      <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
                    </FormField>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes, errors }" rules="required|email">
                    <FormField
                      v-model="email"
                      name="email"
                      type="email"
                      label="Adres e-mail"
                      :class="[classes, 'editorPageContact__formField']"
                    >
                      <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
                    </FormField>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes, errors }" rules="max:12">
                    <FormField v-model="taxId" name="nip" type="text" label="NIP" :class="classes">
                      <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
                    </FormField>
                  </ValidationProvider>
                  <client-only>
                    <ValidationProvider v-slot="{ classes, errors }" rules="required|phone">
                      <FormTel
                        v-model="phone"
                        name="phone"
                        label="Numer telefonu"
                        :class="[classes, 'editorPageContact__formField']"
                      />
                      <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </client-only>

                  <ValidationProvider v-slot="{ classes, errors }" rules="required|max:1000">
                    <FormTextArea
                      v-model="message"
                      name="message"
                      placeholder="Treść wiadomości"
                      :class="classes"
                    />
                    <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="editorPageContact__formAttachment">
                    <p class="editorPageContact__formAttachmentTitle">
                      Dołącz załączniki (opcjonalnie)
                    </p>
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="size:10|ext:jpg,jpeg,png,pdf,doc,docx"
                      ref="fileUploader"
                    >
                      <FileUploader
                        :value="attachments"
                        :class="['editorPageContact__formAttachmentButton']"
                        @input="onFilesChange"
                        button
                      />
                      <span v-if="errors.length" class="formField__error">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <p class="editorPageContact__formAttachmentInfo">
                      Rozmiar pliku do 10MB, w formatach .jpg, .jpeg, .png, .pdf, .doc, .docx
                    </p>
                  </div>
                  <ValidationProvider
                    v-slot="{ classes, errors }"
                    :rules="{ required: { allowFalse: false } }"
                  >
                    <FormCheckbox
                      id="agreement"
                      name="agreement"
                      v-model="agreement"
                      has-html
                      is-medium
                      :class="classes"
                    >
                      Zgadzam się na przetwarzanie moich danych osobowych przez ofix.pl w celu
                      odpowiedzi na moją wiadomość, drogą telefoniczną lub poprzez e‑mail.
                    </FormCheckbox>
                    <span class="formField__error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <VButton
                  class="editorPageContact__formButton"
                  text="Wyślij wiadomość"
                  theme="purple"
                  type="submit"
                  :is-loading="isLoading"
                  :disabled="isLoading"
                />
                <InfoBar
                  v-if="infoBarArray[0].isActive"
                  :message="infoBarArray[0].message"
                  :icon="infoBarArray[0].config.icon"
                  :color="infoBarArray[0].config.color"
                  class="vForm__infoBar editorPageContact__formStatus"
                  @close="hideInfoBar(0)"
                />
              </form>
            </ValidationObserver>
          </VForm>
        </div>
        <div class="editorPageContact__info">
          <div v-if="data.content.FAQ" class="editorPageContact__infoFaq">
            <h2>{{ data.content.FAQ.Title }}</h2>
            <ul>
              <li v-for="(item, index) in data.content.FAQ.Elements" :key="index">
                <a :href="item.Link">{{ item.Title }}</a>
              </li>
            </ul>
          </div>
          <div class="editorPageContact__infoContent">
            <h2>{{ data.content.RegisterData.Title }}</h2>
            <div v-html="data.content.RegisterData.Data"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VForm from '@/components/VForm';
import FormField from '@/components/Form/FormField';
import FormTel from '@/components/Form/FormTel';
import FormTextArea from '@/components/Form/FormTextArea';
import VButton from '@/components/VButton';
import FormCheckbox from '@/components/Form/FormCheckbox';
import FormCheckboxSimple from '@/components/Form/FormCheckboxSimple';
import FileUploader from '@/components/FileUploader';
import InfoBar from '@/components/InfoBar';
import infoBarMixin from '@/mixins/infoBar';
import chatMixin from '~/mixins/chat.js';

export default {
  name: 'EditorPageContact',
  components: {
    InfoBar,
    FileUploader,
    FormCheckboxSimple,
    FormCheckbox,
    VButton,
    VForm,
    ValidationProvider,
    ValidationObserver,
    FormField,
    FormTel,
    FormTextArea,
  },
  mixins: [infoBarMixin(), chatMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      email: '',
      taxId: '',
      phone: '',
      message: '',
      agreement: false,
      attachments: [],
      isLoading: false,
    };
  },
  mounted() {
    if (this.data.top) {
      const zoho = document.querySelector('.zoho');
      if (zoho) {
        zoho.addEventListener('click', this.showChat);
      }
    }
  },
  methods: {
    async onSubmit() {
      this.isLoading = true;
      let message = '';
      const formData = new FormData();
      formData.append('firstAndLastName', this.name);
      formData.append('email', this.email);
      formData.append('taxId', this.taxId);
      formData.append('phone', this.phone);
      formData.append('message', this.message);
      formData.append('agreement', this.agreement);
      this.attachments.forEach(file => formData.append('attachments[]', file));

      try {
        message = await this.$axios.post(
          `${this.$config.baseOfixApi}/e-commerce/v1/contact`,
          formData,
        );
        this.$refs.form.reset();
        this.name = '';
        this.email = '';
        this.taxId = '';
        this.phone = '';
        this.message = '';
        this.agreement = false;
        this.attachments = [];
        this.setInfoBarConfig(0, this.successConfig);
        message = message.data.message;
      } catch (error) {
        if (error.response) {
          message = error.response.data.message
            ? error.response.data.message
            : 'Podczas wysyłania danych z formularza wystąpił błąd.';
        } else {
          message = 'Podczas wysyłania danych z formularza wystąpił błąd.';
        }
        this.setInfoBarConfig(0, this.errorConfig);
      } finally {
        this.isLoading = false;
        this.setInfoBarMessage(0, message);
        this.showInfoBar(0);
      }
    },
    onFilesChange(e) {
      this.$nextTick(() => {
        this.$refs.fileUploader.validate().then(response => {
          if (response.valid) {
            this.attachments = e;
          } else if (response.errors.length) {
            this.$refs.fileUploader.setErrors(response.errors);
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.editorPageContact {
  &__top {
    position: relative;
    border-bottom: 1px solid $cAddLight;
    overflow: hidden;
  }

  &__topInner {
    position: relative;
    z-index: 1;
  }

  &__tiles {
    display: flex;
    margin: 0 -6rem;
    padding: 4rem 15rem 5rem 0;
    flex-wrap: wrap;

    @include rwd('laptop') {
      margin: 0 -4rem;
    }

    @include rwd('large-tablet') {
      padding: 2rem 0 3rem 0;
      margin: 0 -3rem;
    }
  }

  &__tile {
    display: flex;
    margin-bottom: 2rem;
    padding: 0 4rem;
    flex-wrap: wrap;
    align-items: flex-start;

    @include rwd('laptop') {
      padding: 0 2rem;
    }

    @include rwd('large-tablet') {
      padding: 0 3rem;
    }
  }

  &__tileIcon {
    margin-right: 1.5rem;

    @include rwd('laptop') {
      margin-right: 1rem;
      max-width: 2.2rem;
    }
  }

  &__tileContentTitle {
    margin-bottom: 1.5rem;
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 2.8rem;

    @include rwd('laptop') {
      font-size: 1.8rem;
      line-height: 2.4rem;
    }
  }

  &__tileContentText {
    ::v-deep {
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 2.4rem;

      @include rwd('laptop') {
        font-size: 1.4rem;
        line-height: 2.2rem;
      }

      p:not(:first-of-type) {
        margin-top: 1.5rem;
      }

      em {
        font-weight: 400;
        font-style: normal;
        color: $cMainLight;
      }

      a {
        font-weight: 700;
        color: $cMain;
        transition: opacity $tr;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }

  &__topBg {
    position: absolute;
    bottom: 0;
    right: 0;

    @include rwd('small-tablet') {
      display: none;
    }
  }

  &__bottom {
    overflow: hidden;
  }

  &__bottomInner {
    display: flex;
    flex-wrap: wrap;
  }

  &__formWrapper {
    padding: 5rem 13rem 5rem 0;
    flex: 0 0 57.5%;
    max-width: 57.5%;

    @include rwd('laptop') {
      padding: 4rem 6rem 4rem 0;
    }

    @include rwd('large-tablet') {
      padding: 4rem 4rem 4rem 0;
    }

    @include rwd('tablet') {
      padding: 4rem 0;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__formTitle {
    margin-bottom: 3rem;
    font-size: 3.6rem;
    font-weight: 600;
    line-height: 4.5rem;

    @include rwd('laptop') {
      margin-bottom: 2rem;
      font-size: 3rem;
      line-height: 3.8rem;
    }

    @include rwd('tablet') {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  &__formAttachment {
    margin: 3rem 0 2rem 0;
  }

  &__formAttachmentTitle {
    margin-bottom: 1.5rem;
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 2.8rem;

    @include rwd('tablet') {
      font-size: 2rem;
      line-height: 2.6rem;
    }
  }

  &__formAttachmentButton {
    flex-direction: column;
    align-items: flex-start;
  }

  &__formAttachmentInfo {
    margin-top: 1.2rem;
    font-size: 1.4rem;
    line-height: 2.4rem;
    color: $cMainLight;
  }

  &__formButton,
  &__formStatus {
    margin-top: 3rem;
  }

  &__info {
    position: relative;
    display: flex;
    padding: 6.5rem 0 6.5rem 10rem;
    flex-direction: column;
    flex: 0 0 42.5%;
    max-width: 42.5%;

    @include rwd('laptop') {
      padding: 4rem 6rem;
    }

    @include rwd('large-tablet') {
      padding: 4rem 4rem;
    }

    @include rwd('tablet') {
      padding: 4rem 0;
      flex: 0 0 100%;
      max-width: 100%;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 200%;
      height: 100%;
      background-color: $cBg;

      @include rwd('tablet') {
        left: -50%;
      }
    }
  }

  &__infoContent {
    margin-top: 5rem;

    @include rwd('tablet') {
      margin-top: 3rem;
    }
  }

  &__infoContent,
  &__infoFaq {
    position: relative;
    z-index: 1;

    ::v-deep {
      h2,
      h3 {
        font-size: 2.2rem;
        font-weight: 600;
        line-height: 2.8rem;

        @include rwd('laptop') {
          font-size: 2rem;
          line-height: 2.6rem;
        }
      }

      p,
      a {
        margin-top: 1.5rem;
        font-size: 1.8rem;
        line-height: 2.8rem;
        color: $cMainLight;

        @include rwd('laptop') {
          font-size: 1.6rem;
          line-height: 2.6rem;
        }

        @include rwd('small-tablet') {
          font-size: 1.4rem;
          line-height: 2.4rem;
        }
      }

      strong {
        color: $cMainDark;
      }

      ul {
        margin-top: 1.5rem;

        li {
          margin-top: 1rem;

          &:first-child {
            margin-top: 0;
          }
        }
      }

      a {
        margin-top: 0;
        color: $cBlack;
        transition: color $tr;

        &:hover {
          color: $cSec;
        }
      }
    }
  }
}
</style>
